import { ApolloLink } from './ApolloLink';

export const from = ApolloLink.from;



// WEBPACK FOOTER //
// ../../../src/link/core/from.ts